// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.campi-utente-account.con-fab {
  padding-bottom: 4rem;
}`, "",{"version":3,"sources":["webpack://./src/app/_components/campi-utente-account/campi-utente-account.component.scss"],"names":[],"mappings":"AAAA;EAGE,oBAAA;AADF","sourcesContent":[".campi-utente-account.con-fab {\n  // Solo dove il FAB del tab esiste: senza questo spazio coprirebbe l'ultimo campo.\n  // Nel modale il salvataggio è nel footer, e il margine sarebbe vuoto in fondo alla card.\n  padding-bottom: 4rem;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
